import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[uniconDecimalFormatter]',
})
export class UniconDecimalFormatterDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const originalValue = input.value;

    // Permitir solo números y un punto
    let sanitized = originalValue.replace(/[^0-9.]/g, '');

    // Asegurar solo un punto decimal
    const parts = sanitized.split('.');
    if (parts.length > 2) {
      sanitized = parts[0] + '.' + parts.slice(1).join('');
    }

    // Limitar a dos decimales
    if (parts.length === 2) {
      parts[1] = parts[1].substring(0, 1);
      sanitized = `${parts[0]}.${parts[1]}`;
    }

    // Solo asignar si cambia para evitar loop innecesario
    if (sanitized !== originalValue) {
      input.value = sanitized;
    }
  }
}
